<script lang="ts">
export default {
  name: 'DeleteTowerModal',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import AppModal from '@/components/v2/AppModal.vue';
import { TowerCardData } from './types/tower-dashboard';

const title = 'Delete Tower';

const props = defineProps<{
  show: boolean;
  towerCard?: TowerCardData;
  handleCancel?: () => void;
  handleAction?: (towerId: string | undefined) => Promise<void>;
}>();

const towerLabel = computed(() => props.towerCard?.versionLabel ?? 'Tower');

const handleCancel = computed(
  () =>
    props.handleCancel ??
    (() => {
      console.log('cancel');
    }),
);
const handleAction = computed(
  () =>
    props.handleAction ??
    (() => {
      console.log('action');
    }),
);
</script>

<template>
  <AppModal :show="show" :title="title" :handle-cancel="handleCancel" :handle-action="() => handleAction(props.towerCard?.towerId)" action-button-label="Delete">
    <template #content>
      <div class="tw:text-center">
        <p class="tw:text-lg tw:text-gray-600">Are you sure you want to delete this tower?</p>
        <p class="tw:text-lg tw:font-bold tw:text-gray-600">{{ towerLabel }}</p>
      </div>
    </template>
  </AppModal>
</template>
